import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/auth/Login";
import Admin from "../views/Admin";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/admin",
    name: "admin",
    component: Admin,
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("../views/Dashboard"),
      },
      //Setting
      {
        path: "/handicap",
        name: "handicap",
        query: {
          page: 1,
          reverse: "",
          sort: "",
          name: "",
        },
        component: () => import("../views/setting/handicapList"),
      },
      {
        path: "/accumulator",
        name: "accumulator",
        query: {
          page: 1,
          reverse: "",
          sort: "",
          name: "",
        },
        component: () => import("../views/setting/accumulatorList"),
      },
      {
        path: "/finished-fixture",
        name: "finished-fixture",
        query: {
          page: 1,
          reverse: "",
          sort: "",
          name: "",
        },
        component: () => import("../views/setting/finishedList"),
      },
      {
        path: "/ongoing-fixture",
        name: "ongoing-fixture",
        query: {
          page: 1,
          reverse: "",
          sort: "",
          name: "",
        },
        component: () => import("../views/setting/ongoingList"),
      },
      //User Activity List
      {
        path: "/user-utm-report",
        name: "user-utm-report",
        query: {
          page: 10,
          status: true,
          orderBy: "asc",
          sortKey: "created_at",
        },
        component: () => import("../views/utmReport/utmReportList"),
      },
      {
        path: "/user-activity-list",
        name: "user-activity-list",
        query: {
          page: 10,
          status: true,
          orderBy: "asc",
          sortKey: "created_at",
        },
        component: () => import("../views/userActivity/userActivityList"),
      },
      //Master
      {
        path: "/master-list",
        name: "master-list",
        query: {
          page: 1,
          reverse: "",
          sort: "",
          name: "",
        },
        component: () => import("../views/master/masterList"),
      },
      //Agent
      {
        path: "/agent-list",
        name: "agent-list",
        query: {
          page: 1,
          reverse: "",
          sort: "",
          name: "",
        },
        component: () => import("../views/agent/agentList"),
      },
      {
        path: "/agent-create",
        name: "agent-create",
        query: {
          page: 1,
          reverse: "",
          sort: "",
          name: "",
        },
        component: () => import("../views/agent/agentCreate"),
      },
      {
        path: "/agent-edit",
        name: "agent-edit",
        query: {
          page: 1,
          reverse: "",
          sort: "",
          name: "",
        },
        component: () => import("../views/agent/agentEdit"),
      },
      //Bank Info
      {
        path: "/bank-list",
        name: "bank-list",
        query: {
          page: 1,
          reverse: "",
          sort: "",
          name: "",
        },
        component: () => import("../views/bank/bankList"),
      },
      {
        path: "/bank-create",
        name: "bank-create",
        query: {
          page: 1,
          reverse: "",
          sort: "",
          name: "",
        },
        component: () => import("../views/bank/bankCreate"),
      },
      {
        path: "/bank-edit",
        name: "bank-edit",
        query: {
          page: 1,
          reverse: "",
          sort: "",
          name: "",
        },
        component: () => import("../views/bank/bankEdit"),
      },
      //Payment
      {
        path: "/deposit-list",
        name: "deposit-list",
        query: {
          page: 1,
          reverse: "",
          sort: "",
          name: "",
        },
        component: () => import("../views/payment/depositList"),
      },
      {
        path: "/withdraw-list",
        name: "withdraw-list",
        query: {
          page: 1,
          reverse: "",
          sort: "",
          name: "",
        },
        component: () => import("../views/payment/withdrawList"),
      },
      {
        path: "/agent-withdraw-list",
        name: "agent-withdraw-list",
        query: {
          page: 1,
          reverse: "",
          sort: "",
          name: "",
        },
        component: () => import("../views/payment/agentWithdrawList"),
      },
      {
        path: "/deposit-create",
        name: "deposit-create",
        query: {
          page: 1,
          reverse: "",
          sort: "",
          name: "",
        },
        component: () => import("../views/payment/depositCreate"),
      },
      // Member List
      {
        path: "/member-list",
        name: "member-list",
        query: {
          page: 1,
          reverse: "",
          sort: "",
          name: "",
        },
        component: () => import("../views/member/memberList"),
      },
      {
        path: "/agent-member-list",
        name: "agent-member-list",
        query: {
          page: 1,
          reverse: "",
          sort: "",
          name: "",
        },
        component: () => import("../views/member/agentMemberList"),
      },
      //UTM
      {
        path: "/utm-list",
        name: "utm-list",
        query: {
          page: 10,
          status: true,
          orderBy: "asc",
          sortKey: "created_at",
        },
        component: () => import("../views/utm/utmList"),
      },
      {
        path: "/utm-create",
        name: "utm-create",
        query: {
          page: 10,
          status: true,
          orderBy: "asc",
          sortKey: "created_at",
        },
        component: () => import("../views/utm/utmCreate"),
      },
      {
        path: "/utm-edit",
        name: "utm-edit",
        query: {
          page: 10,
          status: true,
          orderBy: "asc",
          sortKey: "created_at",
        },
        component: () => import("../views/utm/utmEdit"),
      },
      //Banner
      {
        path: "/banner-list",
        name: "banner-list",
        query: {
          page: 10,
          status: true,
          orderBy: "asc",
          sortKey: "created_at",
        },
        component: () => import("../views/banner/bannerList"),
      },
      {
        path: "/banner-create",
        name: "banner-create",
        query: {
          page: 10,
          status: true,
          orderBy: "asc",
          sortKey: "created_at",
        },
        component: () => import("../views/banner/bannerCreate"),
      },
      {
        path: "/banner-edit",
        name: "banner-edit",
        query: {
          page: 10,
          status: true,
          orderBy: "asc",
          sortKey: "created_at",
        },
        component: () => import("../views/banner/bannerEdit"),
      },
      //Promotion
      {
        path: "/promotion-list",
        name: "promotion-list",
        query: {
          page: 10,
          status: true,
          orderBy: "asc",
          sortKey: "created_at",
        },
        component: () => import("../views/promotion/promotionList"),
      },
      {
        path: "/promotion-create",
        name: "promotion-create",
        query: {
          page: 10,
          status: true,
          orderBy: "asc",
          sortKey: "created_at",
        },
        component: () => import("../views/promotion/promotionCreate"),
      },
      {
        path: "/promotion-edit",
        name: "promotion-edit",
        query: {
          page: 10,
          status: true,
          orderBy: "asc",
          sortKey: "created_at",
        },
        component: () => import("../views/promotion/promotionEdit"),
      },
      //Notification
      {
        path: "/notification-list",
        name: "notification-list",
        query: {
          page: 1,
          reverse: "",
          sort: "",
          name: "",
        },
        component: () => import("../views/notification/notificationList"),
      },
      {
        path: "/notification-create",
        name: "notification-list",
        query: {
          page: 1,
          reverse: "",
          sort: "",
          name: "",
        },
        component: () => import("../views/notification/notificationCreate"),
      },
      {
        path: "/notification-edit",
        name: "notification-edit",
        query: {
          page: 1,
          reverse: "",
          sort: "",
          name: "",
        },
        component: () => import("../views/notification/notificationEdit"),
      },
      // Report
      {
        path: "/daily-report-list",
        name: "daily-report-list",
        query: {
          page: 1,
          reverse: "",
          sort: "",
          name: "",
        },
        component: () => import("../views/report/dailyList"),
      },
      {
        path: "/agent-report-list",
        name: "agent-report-list",
        query: {
          page: 1,
          reverse: "",
          sort: "",
          name: "",
        },
        component: () => import("../views/report/agentReportList"),
      },
      {
        path: "/member-report-list",
        name: "member-report-list",
        query: {
          page: 1,
          reverse: "",
          sort: "",
          name: "",
        },
        component: () => import("../views/report/memberReportList"),
      },
      {
        path: "/daily-report-nm-list",
        name: "daily-report-nm-list",
        query: {
          page: 1,
          reverse: "",
          sort: "",
          name: "",
        },
        component: () => import("../views/report/dailyNMList"),
      },
      {
        path: "/member-report-nm-list",
        name: "member-report-nm-list",
        query: {
          page: 1,
          reverse: "",
          sort: "",
          name: "",
        },
        component: () => import("../views/report/memberNMReportList"),
      },
      {
        path: "/share/hd",
        name: "Share For Handicap",
        query: {
          page: 1,
          reverse: "",
          sort: "",
          name: "",
        },
        component: () => import("../views/share/ShareUiForHD"),
      },
      {
        path: "/share/acu",
        name: "Share For Acc",
        query: {
          page: 1,
          reverse: "",
          sort: "",
          name: "",
        },
        component: () => import("../views/share/ShareUiForACU"),
      },
    ],
  },

  {
    path: "/*",
    redirect: "/dashboard",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
// Global navigation guard to prevent access to login page if authenticated
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  if (to.path === "/login" && token) {
    // If token exists, redirect to dashboard
    next("/dashboard");
  } else {
    next();
  }
});
